import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IReportSection } from '@modeso/aumico-lib-annualreport-fe';
import { cloneDeep } from 'lodash-es';
import { IReorderingReportData } from '../../interfaces/reordering-report-data.interface';
import { IReportOrderResult } from '@modeso/aumico-lib-annualreport-fe/interfaces/i-report-order.result';

@Component({
    selector: 'app-reorder-report-sections-dialog',
    templateUrl: './reorder-report-sections-dialog.component.html',
    styleUrls: ['./reorder-report-sections-dialog.component.scss'],
})
export class ReorderReportSectionsDialogComponent {
    reorderedReportSections: IReportSection[];
    reportOrder: string[];
    constructor(
        private readonly dialogRef: MatDialogRef<ReorderReportSectionsDialogComponent, IReportOrderResult | undefined>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public reorderingReportData: IReorderingReportData,
    ) {
        this.reorderedReportSections = cloneDeep<IReportSection[]>(reorderingReportData.reportSections);
        this.reportOrder = cloneDeep<string[]>(reorderingReportData.printOrder);
        this.addSvgIcon('interface-delete 1');
        this.addSvgIcon('interface-drag');
    }

    closeDialog(): void {
        this.dialogRef.close(undefined);
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    changeSectionOrder(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.reorderedReportSections, event.previousIndex, event.currentIndex);
        moveItemInArray(
            this.reportOrder,
            this.reportOrder.indexOf(this.reorderedReportSections[event.currentIndex].id),
            event.currentIndex,
        );
    }

    saveAndPrintNewSectionOrders(): void {
        this.dialogRef.close({
            reportSections: this.reorderedReportSections,
            reportsOrder: this.reportOrder,
        });
    }
}
